<template>
    <div class="l-inner">
        <app-section
            :title="page.title"
            :desc="page.desc"
            bgIntro="lighter"
        />
        <push :page="page.page_push" />
    </div>
</template>

<script>

import Push from 'layout/Push';
import AppSection from 'layout/AppSection';
import AnimText from 'objects/AnimText';

export default {
    name: 'Sources',
    components: {
        Push,
        AppSection,
        AnimText,
    },
    props: {
        page: Object,
    },
};
</script>


<style lang="scss">

.p-sources {

    .l-section__desc.t-cms {

        ul {
            @include reset-list;
        }

        li {
            font-size: .75em;

            strong {
                display: block;
                margin-bottom: .25em;
                font-size: 1.25em;
            }

            &:not(:first-child) {
                margin-top: 1em;
            }
        }
    }
}

</style>
